// copied from packages/ui/src/components/FlavorFinder/components/Answer/index.ts
export * from "./FlavorFinderAnswer";
